export const CategoryConst = [
  'ALL',
  'Development',
  'Git',
  'Javascript',
  'NodeJS',
  'React',
  'Typescript',
  'Web',
] as const

export type Category = (typeof CategoryConst)[number]

export const ThemeConst = ['dark', 'light'] as const
export type Theme = (typeof ThemeConst)[number]
